<template>
    <article class="result-card">
        <div class="result-card__image result-card__preview-image" v-if="!hideImage">
            <thumbnail-image :photo-id="resultItem.Image.Id"></thumbnail-image>
        </div>
        <div class="result-card__inner flow">
            <div class="result-card__header">
                <h3 class="result-card__title">
                    <a :href="articleUrl" v-if="!resultItem.IsVirtual && resultItem.Link.Url">
                        {{resultItem.Heading}}
                    </a>
                    <a :href="returnVirtualUrl(resultItem.Url)" v-if="resultItem.IsVirtual && resultItem.Url">
                        {{resultItem.Heading}}
                    </a>
                </h3>
                <!-- <span class="visually-hidden">News</span> -->
            </div>
            <!-- <result-tags :tag-parents="resultItem.TagParents"></result-tags> -->
            <div class="result-card__content flow max-width-s">
                <div class="result-card__meta">
                    <strong>News | </strong>
                    <span>Published {{formatDate(resultItem.Date.DateTime)}}</span>
                    <span v-if="!hideTagsOnResults && topicUrls && Object.keys(topicUrls).length">
                        in
                        <span class="result-card__topics">
                            <span
                                v-for="(url, name) in topicUrls"
                                :key="name"
                                class="topic-item "
                            >
                                <a :href="url">{{ name }}</a>
                            </span>
                        </span>
                    </span>
                </div>
                <!-- <time :datetime="resultItem.Date.DateTime"><strong>{{formatDate(resultItem.Date.DateTime)}}</strong></time> -->
                <p v-if="resultItem.Summary">{{truncate(resultItem.Summary)}}</p>
            </div>
            <div class="result-card__footer text-blue">
                <a :href="returnVirtualUrl(resultItem.Url)"
                   class="btn"
                   aria-labelledby="'news-list-item-' + resultItem.Key"
                   v-if="resultItem.IsVirtual && resultItem.Url">Find out more</a>
                <a :href="articleUrl" class="btn" v-if="!resultItem.IsVirtual && resultItem.Url">
                    Find out more
                    <span class="visually-hidden"> about {{resultItem.Heading}}</span>
                </a>
                <profile-actions :page-id="resultItem.Id.toString()"></profile-actions>
            </div>
        </div>
    </article>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'
    // import ResultTags from '@/components/SiteSearch/result-tags'
    import { globalMixin } from '@/mixins/globalMixin.js'
    import { format, toDate } from '@/utils/date.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage
            // ResultTags
        },

        computed: {
            articleUrl() {
                const url = this.resultItem.Link.Url
                if (!url) return url
                const npid = this.$store.getters.nestedPropertyId
                if (npid) {
                    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'npid=' + npid
                }
                return url
            },
            topicUrls() {
                const topicParent = this.resultItem.TagParents.find(tp => tp.Name === 'Topic')
                if (!topicParent || !topicParent.Children) return null

                const mapping = {}

                topicParent.Children.forEach(childName => {
                    const index = this.resultItem.Tagged.indexOf(childName)

                    if (index >= 0 && this.resultItem.TaggedFilterParamters[index]) {
                        mapping[childName] = this.resultItem.TaggedFilterParamters[index]
                    }
                })

                return Object.keys(mapping).length ? mapping : null
            }
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },

            isMainSite: function () {
                return window.location.host == 'hie.local' || window.location.host == 'hie.co.uk'
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            },
            hideTagsOnResults: {
                default: false,
                required: false,
                type: Boolean
            }
        }
    }
</script>
